// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3829
import type { PAPEventGeneric } from "../base/event";
import type { DashSurface } from "../enums/dash_surface";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { FeatureLine } from "../enums/feature_line";
import type { DashSourceType } from "../enums/dash_source_type";

// Event_name: 'hide.stack_source_row'
// Description: - Shown on the sidebar of the Assistant page when the user is on a Stack Chat
// - Up to 3 different rows in the accordion: `sources`, `unavailable sources` and `newly summarizable sources`
// - The user-facing names are not finalized, but the intent remains the same
// - The row can be clicked to show/hide the associated source tiles.
// Owner: dash-web
export type Hide_StackSourceRow = PAPEventGeneric<
  'dash',
  'hide',
  'stack_source_row',
  {
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // This defines where the document source is
    dashSourceType?: DashSourceType;
  }
>;

export function PAP_Hide_StackSourceRow(properties?: Hide_StackSourceRow['properties']): Hide_StackSourceRow {
  return <Hide_StackSourceRow>{
    class: 'dash',
    action: 'hide',
    object: 'stack_source_row',
    properties,
  };
}
